import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';

const UserAvatar = ({ user = {}, size = 30, src = null, style = {} }) => {
  const baseStyle = {
    marginRight: 8,
    display: 'inline-flex',
    verticalAlign: 'middle',
    width: size,
    height: size,
    ...style,
  };
  const url = src || (user && user.avatar && user.avatar.url);
  if (url) {
    return <Avatar src={url} style={baseStyle} />;
  }
  if (user && user.first_name && user.last_name) {
    return (
      <Avatar
        style={{ ...baseStyle, color: '#fff', backgroundColor: '#adc6eb' }}
      >
        {user.first_name.charAt(0).toUpperCase()}
        {user.last_name.charAt(0).toUpperCase()}
      </Avatar>
    );
  }
  return <div />;
};

UserAvatar.propTypes = {
  user: PropTypes.object,
  size: PropTypes.number,
  src: PropTypes.string,
  style: PropTypes.object,
};

export default UserAvatar;
